import z from "zod";

import { UserSchema } from "../user/userSchema";

export const AutosaveSchema = z.object({
  key: z.string(),
  time: z.string(),
  uid: UserSchema.shape.user_id.optional(),
  created_by: UserSchema.optional().catch(undefined),
});

export const AutosavesSchema = z.array(AutosaveSchema);

export const GroupedAutosavesSchema = z.record(
  z.string(),
  z.array(AutosaveSchema)
);

export type IAutosaves = z.infer<typeof AutosavesSchema>;
export type IGroupedAutosaves = z.infer<typeof GroupedAutosavesSchema>;
